<template>
    <v-card
        flat
        class  = "lm-border doc-entry mb-1 mr-1 v-flex"
        @click = "onShowDocument"
    >
         <div style="display: block" class="pl-2 doc-col" :class = "background(hover)">
            <div class="doc-info v-flex">
                <!-- document type -->
                <div class="doc-filename">
                    {{ version.name }}
                </div>
                <!-- document type -->

                <v-spacer />
            </div>

            <div class="doc-subinfo doc-filename">
                Version {{ version.version }}
            </div>
        </div>

        <v-spacer :class = "background(hover)" />

        <div style="display: block" :class = "background(hover)" class="doc-col">
            <div class="doc-date pr-2">
                {{ timeAsString(version.createdDate) }}
            </div>
            <div class="doc-subinfo" style="margin-top: -2px">
                {{ version.createdBy }}
            </div>
        </div>

        <div style="padding-top: 10px;" :class = "background(hover)">
            <v-menu
                v-model = "menu"
                offset-x
            >
                <template v-slot:activator="{ props }">
                    <a
                        @click.stop = "onMenu"
                        v-bind="props"
                        style="margin-top: -5px"
                    >
                        <v-icon size="24" :color = "hover || menu ? 'white' : ''">mdi-dots-vertical</v-icon>
                    </a>
                </template>

                <v-list style="width: 250px; font-size: 15px">
                    <v-list-item @click="onShowDocument">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <i class="fas fa-eye"></i>
                            </div>
                            <div>{{ $t("dms.entry.menu.show") }}</div>
                        </div>
                    </v-list-item>

                    <v-list-item @click="onDownload">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <i class="fas fa-download menu-icon"></i>
                            </div>
                            <div>{{ $t("dms.entry.menu.download") }}</div>
                        </div>
                    </v-list-item>

                    <v-divider class="mt-2 mb-2" />

                    <v-list-item link>
                        <c-app-confirm-menu
                            :text      = "$t('dms.version.confirm.restore.query')"
                            :subtext   = "$t('dms.version.confirm.restore.text')"
                            @confirmed = "onRestore"
                        >
                            <template v-slot:button>
                                <div class="v-flex">
                                    <div class="menu-icon">
                                        <i class="fas fa-recycle"></i>
                                    </div>
                                    <div>
                                        {{ $t("dms.version.menu.restore") }}
                                    </div>
                                </div>
                            </template>
                        </c-app-confirm-menu>
                    </v-list-item>

                    <v-list-item link>
                        <c-app-confirm-menu
                            :text      = "$t('dms.version.confirm.delete.query')"
                            :subtext   = "$t('dms.version.confirm.delete.text')"
                            @confirmed = "onRemove"
                        >
                            <template v-slot:button>
                                <div class="v-flex">
                                    <div class="menu-icon">
                                        <i class="fas fa-trash-alt"></i>
                                    </div>
                                    <div>
                                        {{ $t("dms.version.menu.remove") }}
                                    </div>
                                </div>
                            </template>
                        </c-app-confirm-menu>
                    </v-list-item>
             </v-list>
            </v-menu>
        </div>
    </v-card>
</template>

<script>

import Core from "@/modules/core/service/Core";
import Dms  from "@/modules/dms/common/service/Dms";
import CAppConfirmMenu from "@/modules/core/components/app/CAppConfirmMenu.vue";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "PDmsVersion",

    components: {
        CAppConfirmMenu
    },

    props: {
        stepDataId: {

        },

        document: {

        },

        version: {

        } ,

        hover: {

        },
    },

    data: () => ({
        menu: false,
    }),

    computed: {
        versions () {
            if (!this.document.versions || this.document.versions.length === 0) {
                return null;
            }

            return this.document.versions;
        }
    },

    methods: {
        onMenu () {
            this.menu = !this.menu;
        },

        /**
         * Called when the user selects a document by the document's context menu.
         */
        onShowDocument () {
            Dms.open(this.version.id, this.version.name);
        },

        /**
         * Called when the user selects the download button in the entry menu.
         */
        onDownload () {
            Dms.download(this.version.id, (filename, data)  => {
                let link = document.createElement('a');
                link.href = data;
                link.download = filename ? filename : this.version.name;
                link.click()
            });
        },

        onRestore () {
            Inc.document.versions.restore(this, this.document.id, this.version.id).then((data) => {
                console.log("restore", data, this.stepDataId)
                this.$bus.$emit(Dms.event.document.refresh, {
                    id       : this.stepDataId,
                    documents: data
                });

                Core.message.hint(this, this.$t("dms.entry.message.version.restored"));
            }).catch(() => {});
        },

        /**
         * Called when the user selects the delete button in the entry menu.
         */
        onRemove () {
            Inc.document.versions.remove(this, this.document.id, this.version.id).then(() => {
                this.$emit("removed", this.version);
                Core.message.hint(this, this.$t("dms.entry.message.version.removed"));
            }).catch(() => {});
        },

        onSelected (value) {
            this.$emit("selected", {
                id      : this.document.id,
                selected: value
            });
        },

        background (hover) {
            if (this.menu) {
                return "background-selected";
            }

            return hover ? 'primary white--text' : ' black--text'
        },

        timeAsString (value) {
            return Core.format.datetime.display(value);
        }
    }
}
</script>

<style scoped>

.doc-info {
    font-size: 14px;
    padding-top: 1px;
}

.doc-col {
    padding-top: 2px;
    padding-bottom: 0;
}

.doc-date {
    font-size: 12px;
    margin-top: 4px;
}

.doc-subinfo {
    font-size: 11px;
    margin-top: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.doc-filename {
    max-width: 350px;
    width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.menu-icon {
    width: 30px;
    min-width: 30px;
    text-align: left;
}

</style>